import PropTypes from 'prop-types';
import React from 'react';

import {
    Header,
    Footer,
    Meta
} from '$partials/global';

import Util from '$utilities';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props.err.status) || 500;

    const page = props?.data?.page;
    let message = '';

    switch(status) {
    case 404:
        message = 'Page not found.';
        break;

    default:
        message = 'Sorry, something went wrong.';
    }

    const title = Util.try(() => page.title) || '404';

    return (
        <>
            <Meta/>

            <Header
                {...props?.data?.navigation}
                {...props?.data?.ticker}
                pageType={page?.__typename} />

            <main id='main-content bg-white'>
                <section className='layout-container pb-100'>
                    <div className='layout-grid-negative-gutter md:flex'>
                        <div className='md:w-1/12 layout-grid-col-padding' />

                        <div className='sm:w-8/12 md:w-7/12 layout-grid-col-padding'>
                            {title && (
                                <h1 className='type-style-4 pb-30'>{title}</h1>
                            )}

                            {message && (
                                <p className='type-style-1 pb-30 md:pb-35'>{message}</p>
                            )}

                            <p className='rich-text type-style-4'>
                                <a href='/'>Click here</a> to return to the main site.
                            </p>
                        </div>
                    </div>
                </section>
            </main>

            <Footer
                {...props?.data?.footer}
                {...props?.data?.newsletter} />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.object,
    err: PropTypes.object
};

ErrorPage.propTypes = propTypes;

export default ErrorPage;
